import type { ParentProps } from "solid-js"

export function ReservedPlaceholder(props: ParentProps<{ title: string }>) {
  return (
    <div class="flex-1 flex flex-col items-center justify-center text-v2-text-text-muted gap-2 min-h-0">
      <h2 class="text-xl font-medium">{props.title}</h2>
      <p class="text-sm">研发中，敬请期待</p>
    </div>
  )
}

export function ConnectorsPage() {
  return <ReservedPlaceholder title="连接器" />
}
